import { formatDateBR } from "@/lib/date-utils";
import type { StayHistoryRow } from "@/hooks/usePatientHistoryFeed";

/**
 * Título, detalhe e cobertura de uma estadia no histórico. O título identifica
 * o módulo; o detalhe apresenta o intervalo completo de entrada e saída; a
 * cobertura diz se foi debitada de um plano, se faltou, ou nada (avulso).
 */
export function formatStayHistoryLabel(
  row: StayHistoryRow,
  t: (key: string, options?: Record<string, unknown>) => string,
): { title: string; detail: string | null; coverage: string | null } {
  const moduleLabel = row.moduleType === "hotel" ? t("historyTab.stay.hotel") : t("historyTab.stay.daycare");
  const start = row.checkInDate ?? row.stayDate;
  const end = row.checkOutDate ?? start;
  const title = moduleLabel;
  const startLabel = `${formatDateBR(start)}${row.checkInTime ? ` ${row.checkInTime.slice(0, 5)}` : ""}`;
  const endLabel = `${formatDateBR(end)}${row.checkOutTime ? ` ${row.checkOutTime.slice(0, 5)}` : ""}`;

  // A falta é o que explica o plano não ter sido debitado, então ela aparece.
  const coverage = row.status === "no_show"
    ? t("historyTab.stay.noShow")
    : row.planName
      ? t("historyTab.stay.coveredByPlan", { planName: row.planName, units: row.planUnits ?? 1 })
      : null;

  return { title, detail: `${startLabel} até ${endLabel}`, coverage };
}
